import { Pipe, PipeTransform } from '@angular/core';
import get from 'lodash/get';
import isString from 'lodash/isString';

@Pipe({
    name: 'sort',
    standalone: true,
})
export class ArraySortPipe implements PipeTransform {
  transform(items: any[], field: string, desc: boolean = true, active: boolean = true): any[] {
    if (!items || !active) return items;
    const array = [...items];

    array.sort((a: any, b: any) => {
      let first = a[field],
        second = b[field];
      if (field === 'updated_at') {
        first = new Date(first);
        second = new Date(second);
      } else if (field.includes('.')) {
        first = get(a, field);
        second = get(b, field);
        if (!first) first = 0;
        if (!second) second = 0;
        //console.log("[Sorting by Impressions]",first,second);
      } else {
        if (isString(a[field])) {
          first = a[field].toLowerCase();
        }
        if (isString(b[field])) {
          second = b[field].toLowerCase();
        }
      }
      if (!desc) {
        if (first < second) {
          return -1;
        } else if (first > second) {
          return 1;
        } else {
          return 0;
        }
      } else {
        if (first > second) {
          return -1;
        } else if (first < second) {
          return 1;
        } else {
          return 0;
        }
      }
    });
    return array;
  }
}
